const activities = [
  { id: 1, icon: 'ri-robot-line', text: 'IA gerou título alternativo para "Prefeitura anuncia..."', time: '5 min', type: 'ai' },
  { id: 2, icon: 'ri-check-double-line', text: 'Carlos Mendes aprovou artigo sobre mobilidade urbana', time: '12 min', type: 'approve' },
  { id: 3, icon: 'ri-layout-grid-line', text: 'Layout da Edição 14820 gerado automaticamente', time: '28 min', type: 'layout' },
  { id: 4, icon: 'ri-image-add-line', text: 'Fernanda Lima adicionou 3 imagens ao artigo de esportes', time: '45 min', type: 'media' },
  { id: 5, icon: 'ri-file-pdf-line', text: 'PDF da Edição 14819 exportado com sucesso', time: '1h', type: 'export' },
  { id: 6, icon: 'ri-advertisement-line', text: 'Novo anúncio da Joalheria Brilhante adicionado', time: '2h', type: 'ad' },
];

const typeColors: Record<string, string> = {
  ai: 'text-[#5B2D8E]',
  approve: 'text-[#1a7a1a]',
  layout: 'text-[#0066AA]',
  media: 'text-[#B8860B]',
  export: 'text-[#C41230]',
  ad: 'text-[#444444]',
};

export default function RecentActivity() {
  return (
    <div className="bg-white border border-[#E0E0E0]">
      <div className="px-5 py-3 border-b-2 border-[#111111] flex items-center justify-between">
        <h2 className="text-sm font-bold text-[#111111] font-serif uppercase tracking-wide">Atividade Recente</h2>
        <button className="text-[11px] text-[#C41230] font-semibold font-sans cursor-pointer hover:underline">Ver histórico</button>
      </div>
      <div className="divide-y divide-[#F0F0F0]">
        {activities.map((a) => (
          <div key={a.id} className="flex items-start gap-3 px-5 py-3 hover:bg-[#F8F8F8] transition-colors">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className={`${a.icon} ${typeColors[a.type]} text-sm`}></i>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-[#333333] font-sans leading-relaxed">{a.text}</p>
              <p className="text-[10px] text-[#999999] mt-0.5 font-sans">há {a.time}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
